import { makeAutoObservable, runInAction } from "mobx";
import { OrderIssueController } from "./Order/OrderIssueController";
import { StockistIssue } from "../DTOs/StockistIssue";
import { basketController } from "./BasketController";

class StorageController {
  orderIssueControllers: { [issueId: number]: OrderIssueController } = {};

  getOrCreateStore(issue: StockistIssue): OrderIssueController {
    // Always sync inBasket from the live basket before touching the store
    const basketQuantity = basketController.basket?.items.find(i => i.issueId === issue.id)?.quantity ?? 0;
    issue.stock.inBasket = basketQuantity;

    const existingController = this.orderIssueControllers[issue.id];

    if (!existingController) {
      const controller = new OrderIssueController(issue);

      runInAction(() => this.orderIssueControllers[issue.id] = controller);
      return controller;
    }

    existingController.updateStore(issue);
    return existingController;
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export const storageController = new StorageController();